// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","pointer":"App_pointer__r2e6V"};